import { Button, Typography, Dialog, DialogContent, DialogActions, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StockCountCreateContext, StockCountCreateValues } from '../../contexts/StockCountCreateContext';
import { useContext } from 'react';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';

const StockCountCreateDeleteCountZoneTypesModal = () => {
  const { isCountZoneTypesDeleteModalOpen,
    handleClose,
    deleteCountZoneTypes,
    countZoneTypesData,
    countZoneTypeId } = useContext(StockCountCreateContext) as StockCountCreateValues;

  const { t } = useTranslation('createStockCount');

  const handleConfirm = () => {
    if (countZoneTypeId !== undefined) {
      const data = countZoneTypesData?.filter(item => item.id !== countZoneTypeId);
      deleteCountZoneTypes(data);
    }
    else {
      deleteCountZoneTypes([]);
    }
  };

  return (
    <Dialog open={isCountZoneTypesDeleteModalOpen}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth>
      <DialogTitle>
        {t('countZoneTypes.delete')}
        <CloseDialogAction onCancel={handleClose} />
      </DialogTitle>
      <DialogContent>
        <Typography>{t('countZoneTypes.deleteMessage')}</Typography>
      </DialogContent>
      <DialogActions >
        <Button
          variant="secondary"
          size='lg'
          onClick={handleClose}> {t('cancel')}</Button>
        <Button variant="bad"
          size='lg'
          onClick={handleConfirm}>
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StockCountCreateDeleteCountZoneTypesModal;
